import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const EmailStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      min-height: 100%;
    }

    .email-title {
      margin: 0 0 8px;
      text-align: center;
    }

    .email-subtitle {
      margin: 0;
      text-align: center;
    }

    .email-spacer {
      flex: 1;
    }

    .email-input-container {
      max-width: 372px;
      padding: 0 16px;
      width: 100%;
      margin: 0 auto;
    }

    .email-protection {
      margin: 16px auto 24px;
      padding: 0 16px;
      max-width: 372px;
    }
  }
`;

export const OverlayStyles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    #14111e 0%,
    rgba(20, 17, 30, 0.8) 20.03%,
    rgba(20, 17, 30, 0) 32.68%,
    rgba(20, 17, 30, 0) 66.53%,
    rgba(20, 17, 30, 0.789211) 77.66%
  );
  z-index: 0;
  pointer-events: none;
`;
